import ACRed from "./ACRed"
import AfterSchool from "./AfterSchool"
import Lux from "./Lux"
import Alka from "./Alka"
import CentreNationalExposition from "./CentreNationalExposition"
import TimeSwap from "./TimeSwap"
import DroidRush from "./DroidRush"
import LoadingGif from '../../../../Assets/img/loading-gif.gif'

const projects = {
    'Assassin\'s Creed Shadows': ACRed,
    'After School': AfterSchool,
    'Droid Rush' : DroidRush,
    'Lux': Lux,
    'ALKA': Alka,
    'Centre National d\'Exposition' : CentreNationalExposition,
    'Time Swap' : TimeSwap,
}

const images = {
    'LoadingGif': LoadingGif,
}

export { projects, images }